import throttle from 'lodash.throttle';

const DashboardController = function () {
	this.onRefreshCallbacks = [];
	this.refresh = (optionalDrugBoxId) => {
		for (let i in this.onRefreshCallbacks){
			this.onRefreshCallbacks[i](optionalDrugBoxId || localStorage.lastBoxId);

		}
	}
	this.refreshThrottled = throttle(this.refresh ,1000,  { leading: true, trailing: false });
	this.onRefresh = (callback) => {
		this.onRefreshCallbacks.push(callback);
	};
}

const dashboardController = new DashboardController();
export default dashboardController